<template>
	<div class="content">
		<Customer :autoload="true" :id="getId()" />
	</div>
</template>

<script>
export default {
  methods: {
    getId () {
      return this.$route.params.id
    }
  },
  watch: {
    $route: function () {
      this.$router.go(0)
    }
  }
}
</script>
